import { useSearchParams } from "react-router";
import { readSheet, upcomingIdOf } from "../lib/sheets";
import { BandSheet } from "./sheets/BandSheet";
import { DraftSheet } from "./sheets/DraftSheet";
import { FlyerSheet } from "./sheets/FlyerSheet";
import { PersonSheet } from "./sheets/PersonSheet";
import { ShowSheet } from "./sheets/ShowSheet";
import { VenueSheet } from "./sheets/VenueSheet";
import { YearSheet } from "./sheets/YearSheet";

/** Renders whichever sheet the URL names, over any page. `key` remounts on a new target. */
export function SheetHost() {
  const [sp] = useSearchParams();
  const open = readSheet(sp);
  if (!open) return null;
  const id = Number(open.value);
  switch (open.kind) {
    case "show":
      return <ShowSheet key={id} id={id} />;
    case "edit":
      return <DraftSheet key={`e${id}`} mode="edit" showId={id} />;
    case "log":
      return <DraftSheet key={`l${open.value}`} mode="log" upcomingId={upcomingIdOf(open.value)} />;
    case "flyer":
      return <FlyerSheet key={id} showId={id} />;
    case "band":
      return <BandSheet key={id} id={id} />;
    case "venue":
      return <VenueSheet key={id} id={id} />;
    case "year":
      return <YearSheet key={id} year={id} />;
    case "person":
      return <PersonSheet key={id} id={id} />;
  }
}
